import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="show-password"
export default class extends Controller {
  static targets = ["input", "toggle"]

  connect() {
    this.updateIcon()
  }

  toggle() {
    const input = this.inputTarget
    input.type = input.type === "password" ? "text" : "password"
    this.updateIcon()
  }

  updateIcon() {
    const icon = this.toggleTarget.querySelector("svg")
    if (!icon) return
    if (this.inputTarget.type === "password") {
      icon.innerHTML = `<path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M15 12a3 3 0 11-6 0 3 3 0 016 0z\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z\" />`
    } else {
      icon.innerHTML = `<path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.956 9.956 0 012.293-3.95m3.362-2.568A9.956 9.956 0 0112 5c4.477 0 8.268 2.943 9.542 7a9.973 9.973 0 01-4.293 5.03M15 12a3 3 0 11-6 0 3 3 0 016 0z\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 3l18 18\" />`
    }
  }
} 